import { adminConsoleApplicationId } from '@logto/schemas';

import { searchKeys } from '@/shared/utils/search-parameters';

/**
 * Returns true when the current session is for the LandingAI app (i.e. not the admin console).
 * The app_id is written to sessionStorage by handleSearchParametersData() at module-load time
 * in App.tsx, so this helper is safe to call synchronously during render.
 */
export const isLandingApp = (): boolean => {
  const appId = sessionStorage.getItem(searchKeys.appId);
  return appId !== adminConsoleApplicationId;
};
